import TriggerConfigSerializer from 'eflex/serializers/trigger-config';

export default class NodeRedTriggerConfigSerializer extends TriggerConfigSerializer {}
